import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getUf, getUfs } from "../../services/apiUf";
import { getCidade, putCidade } from "../../services/apiCidade";
import { erroToastify, sucessoToastify } from "../../shared/validacaoToastify";
import SelectGenerico from "../../components/selectGenerico/selectGenerico";
import InputGenerico from "../../components/inputGenerico/inputGenerico";
import { CamposPadroes } from "../../shared/CamposPadroes";
import { ToastContainer } from "react-toastify";
import "./cidade.css";
import "react-toastify/dist/ReactToastify.css";
import { Helmet } from "react-helmet";

function AlterarCidade() {
  const navigate = useNavigate();
  const { cdCidade } = useParams();
  const inputRef = useRef<HTMLInputElement>(null);
  const selectRef = useRef<HTMLSelectElement>(null);
  const [exibirSucesso, setExibirSucesso] = useState(false);
  const [validacaoAtiva, setValidacaoAtiva] = useState<any>(false);
  const [cidade, setCidade] = useState<{ nomeCidade: string; cdUf: String }>();
  const [formValues, setFormValues] = useState({
    nomeCidade: "",
    cdUfSelecionada: "",
  });
  const [ufs, setUfs] = useState<
    { nmSigla: string; cdUf: number; nmUf: string }[]
  >([]);
  const [uf, setUf] = useState<{
    nmSigla: string;
    cdUf: Number;
    nmUf: string;
  }>();
  const fetchCidade = async (cd: any) => {
    try {
      const response = await getCidade(cd);
      setFormValues({
        nomeCidade: response.data.nmCidade,
        cdUfSelecionada: response.data.cdUf,
      });
      setCidade({
        nomeCidade: response.data.nmCidade,
        cdUf: response.data.cdUf,
      });
    } catch (error) {
      console.error(error);
    }
  };
  const fetchUf = async () => {
    try {
      if (formValues.cdUfSelecionada) {
        const response = await getUf(Number(formValues.cdUfSelecionada));
        setUf(response.data);
      }
    } catch (error) {
      console.error(error);
    }
  };
  const fetchUfs = async () => {
    try {
      const response = await getUfs("1");
      setUfs(response.data);
    } catch (error) {
      console.error(error);
    }
  };
  const handleFieldChange = (name: string, value: string | number) => {
    setFormValues({ ...formValues, [name]: value });
    setValidacaoAtiva(false);
  };
  const handleConfirmar = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const IgualACidade =
      formValues.nomeCidade === cidade?.nomeCidade &&
      formValues.cdUfSelecionada === cidade?.cdUf;
    if (IgualACidade) {
      const successMessage = "A cidade foi alterada com sucesso!";
      navigate(
        `/milshop/consultar/cidades?successMessage=${encodeURIComponent(
          successMessage
        )}`
      );
      return;
    }
    const dataPresente = new Date();
    const envioDeDados = {
      cdCidade: cdCidade,
      nmCidade: formValues.nomeCidade,
      cdUf: formValues.cdUfSelecionada ? formValues.cdUfSelecionada : 0,
      ...CamposPadroes.toObjeto(
        1,
        1,
        dataPresente.toISOString(),
        dataPresente.toISOString(),
        true
      ),
    };
    try {
      const response = await putCidade({
        ...envioDeDados,
      });
      const successMessage = "A cidade foi alterada com sucesso!";
      navigate(
        `/milshop/consultar/cidades?successMessage=${encodeURIComponent(
          successMessage
        )}`
      );
    } catch (error: any) {
      if (error.response.data) {
        erroToastify(error.response.data);
        setValidacaoAtiva(true);
      }
    }
  };

  useEffect(() => {
    fetchCidade(cdCidade);
  }, [cdCidade]);
  useEffect(() => {
    fetchUfs();
  }, []);
  useEffect(() => {
    fetchUf();
  }, [formValues]);
  useEffect(() => {
    if (validacaoAtiva && !formValues.cdUfSelecionada && selectRef.current) {
      selectRef.current.focus();
    } else if (validacaoAtiva && !formValues.nomeCidade && inputRef.current) {
      inputRef.current.focus();
    }
  }, [validacaoAtiva, formValues.cdUfSelecionada, formValues.nomeCidade]);

  return (
    <>
      <Helmet>
        <title>Alterar cidade</title>
      </Helmet>
      <div className="container mt-5">
        <div className="row justify-content-center">
          <div className="col-md-6 bg-light rounded shadow p-4">
            <form className="mb-3" onSubmit={handleConfirmar}>
              {uf && (
                <SelectGenerico
                  opcoes={ufs.map((uf) => ({
                    valor: uf.cdUf,
                    rotulo: `(${uf.nmSigla}) ${uf.nmUf}`,
                  }))}
                  valorSelecionado={formValues.cdUfSelecionada}
                  onChange={(value: string | number) =>
                    handleFieldChange("cdUfSelecionada", value)
                  }
                  label="Estado"
                  mensagemError="Não há Estados a serem listados"
                  opcaoPadrao={`(${uf.nmSigla}) ${uf.nmUf}`}
                  classe={`selectUf form-select mb-3  ${!formValues.cdUfSelecionada && validacaoAtiva
                      ? "select-invalid"
                      : ""
                    }`}
                  classPadrao="corOption"
                  validacaoAtiva={validacaoAtiva}
                  ref={selectRef}
                />
              )}

              <InputGenerico
                name="nomeCidade"
                value={formValues.nomeCidade}
                onChange={(event: {
                  target: { name: string; value: string | number };
                }) => handleFieldChange(event.target.name, event.target.value)}
                label="Nome da Cidade"
                placeholder={`${formValues.nomeCidade}`}
                className={`form-control ${!(formValues.nomeCidade.length > 2) && validacaoAtiva
                    ? "input-invalid"
                    : ""
                  }`}
                validacaoAtiva={validacaoAtiva}
                ref={inputRef}
                type="text"
              />
              <div className="d-flex mt-4">
                <a
                  className="btn btn-outline-danger me-2 btn-sm"
                  href="/milshop/consultar/cidades"
                  role="button"
                  style={{ width: "100px" }}
                >
                  Cancelar
                </a>
                <button
                  type="submit"
                  className="btn btn-outline-primary btn-sm"
                  style={{ width: "100px" }}
                >
                  Alterar
                </button>
              </div>
            </form>
          </div>
        </div>
        <ToastContainer />
      </div>
    </>
  );
}
export default AlterarCidade;
